@if (!isTranscriptAvailable() && isTranscriptLoading()) {
<av-card-row class="text-center">
  <av-spinner size="sm"></av-spinner>
</av-card-row>
} @if (!isTranscriptAvailable() && !isTranscriptLoading()) {
<av-card-row class="info-row">
  <av-card-row-responsive class="fx-flex-1" [flex]="1">
    <ng-container card-row-title>
      <av-card-row-column label="Select the language of the recording.">
        <ng-container column-value>
          <select
            class="full-width"
            name="providerlanguage"
            [(ngModel)]="activeLanguage"
          >
            <option selected value="" disabled>-</option>
            @for (l of languages(); track l) {
            <option [ngValue]="l">
              {{ l.name }}
            </option>
            }
          </select>
        </ng-container>
      </av-card-row-column>
    </ng-container>
    <ng-container card-row-body>
      <av-card-row-column>
        <ng-container column-value>
          <div class="fx-row fx-gap-10 fx-align-start fx-justify-space-between">
            <div class="control">
              <button
                avButton
                [disabled]="isGenerateTranscriptDisabled()"
                (click)="requestTranscript()"
                color="accent"
                class="fx-gap-10"
                data-tid="composition/transcript"
                [raised]="true"
                [loading]="isTranscriptLoading()"
              >
                <av-icon size="sm" name="transcript"></av-icon>
                {{ "Generate transcript" | translate }}
              </button>
            </div>
          </div>
        </ng-container>
      </av-card-row-column>
    </ng-container>
  </av-card-row-responsive>
</av-card-row>
} @if (isTranscriptProcessing()) {
<av-card-row>
  <span translate>Processing transcript. Please wait...</span>
</av-card-row>
} @if (isTranscriptSubmitted()) {
<av-card-row>
  <span translate>Transcript submitted for processing. Please wait...</span>
</av-card-row>
} @if (isTranscriptCompleted()) {
<av-card-row>
  <av-card-row-responsive
    class="transcript-row"
    flex="1"
    [bodyHidden]="true"
    icon="file-transcript"
  >
    <ng-container card-row-title>
      {{ transcriptTitle() }}
    </ng-container>
    <ng-container card-row-subtitle>
      {{
        transcriptStatus().createdAt
          | dayjsFormat : "MMM D YYYY, h:mm a" : lang
      }}
    </ng-container>
    <ng-container card-row-actions>
      <div class="fx-row fx-gap-10 fx-align-center fx-justify-space-between">
        @if (isSummarizeAvailable) {
        <div class="control">
          <button
            avButton
            ofType="icon"
            color="accent"
            size="sm"
            data-tid="composition/summary"
            [raised]="true"
            (click)="summarize()"
            [disabled]="isSummarizeDisabled()"
          >
            <av-icon name="summary"></av-icon>
          </button>
          <div translate>Summarize</div>
        </div>
        } @if (isTranslateAvailable) {
        <div class="control">
          <div class="control-popup">
            <button
              avButton
              ofType="icon"
              color="accent"
              size="sm"
              data-tid="composition/translate"
              [raised]="true"
              (click)="isTranslatePopupOpen.set(true)"
              [disabled]="isTranslateDisabled()"
            >
              <av-icon name="translation"></av-icon>
            </button>
            @if (isTranslatePopupOpen()) {
            <av-card
              [popup]="true"
              arrow="bottom-right"
              hAlign="right"
              vAlign="top"
              [backdrop]="false"
              class="translate-popup"
            >
              <av-card-header
                subtitle="Select the language for translation"
                (close)="isTranslatePopupOpen.set(false)"
                >{{ "Language" | translate }}</av-card-header
              >
              <av-card-body>
                <select
                  class="full-width"
                  name="translatelanguage"
                  [(ngModel)]="translateLanguage"
                >
                  <option selected value="" disabled>-</option>
                  @for (l of translationLanguages(); track l) {
                  <option [ngValue]="l">
                    {{ l.name }}
                  </option>
                  }
                </select>
              </av-card-body>
              <av-card-footer>
                <button
                  avButton
                  (click)="translate()"
                  color="accent"
                  size="block"
                  data-tid="composition/transcript/translate"
                  translate
                  [disabled]="!translateLanguage"
                >
                  Translate
                </button>
              </av-card-footer>
            </av-card>
            }
          </div>
          <div translate>Translate</div>
        </div>
        } @if (isSentimentAvailable) {
        <div class="control">
          <button
            avButton
            ofType="icon"
            color="accent"
            size="sm"
            data-tid="composition/sentiment"
            [raised]="true"
            (click)="analyze()"
            [disabled]="isSentimentDisabled()"
          >
            <av-icon name="sentiment"></av-icon>
          </button>
          <div translate>Sentiment</div>
        </div>
        } @if (isPromptAvailable) {
        <div class="control">
          <div class="control-popup">
            <button
              avButton
              ofType="icon"
              color="accent"
              size="sm"
              data-tid="composition/prompt"
              [raised]="true"
              (click)="prompt()"
              [disabled]="isPromptDisabled()"
            >
              <av-icon name="prompt"></av-icon>
            </button>
          </div>
          <div translate>Custom</div>
        </div>
        } @if (canRequestFormattedTranscript) {
        <av-tooltip message="Content">
          <button
            [attr.aria-label]="'Content' | translate"
            avButton
            size="xs"
            ofType="icon"
            color="link"
            (click)="toggleContent()"
            [loading]="isLoadingContent()"
            [disabled]="isLoadingContent()"
          >
            <av-icon
              [class.expanded]="isContentExpanded()"
              size="sm"
              name="chevron-down"
            ></av-icon>
          </button>
        </av-tooltip>
        }
        <div class="control-separator"></div>
        <av-confirm
          [open]="confirmRemove()"
          (confirmed)="removeTranscript()"
          (canceled)="confirmRemove.set(false)"
          arrow="bottom-right"
        >
          <button
            avButton
            ofType="icon"
            color="danger"
            size="xxs"
            [loading]="isLoadingDelete()"
            [disabled]="isDeleteTranscriptDisabled()"
            (click)="confirmRemove.set(true)"
          >
            <av-icon size="xs" name="trash"></av-icon>
          </button>
          <span confirmTitle translate>Are you sure?</span>
          <!-- <div confirmBody>
              {{
              "You can only export one language per recording. The existing transcript will be removed."
              | translate
              }}
            </div>-->
        </av-confirm>
        @if (!canRequestFormattedTranscript && !transcriptUrl()) {
        <av-tooltip message="Get download link">
          <button
            [attr.aria-label]="'Get download link' | translate"
            avButton
            ofType="icon"
            color="link"
            size="xs"
            data-tid="composition/download"
            [loading]="isLoadingURL()"
            (click)="getDownloadLink()"
          >
            <av-icon size="sm" name="link"></av-icon>
          </button>
        </av-tooltip>
        } @if (canRequestFormattedTranscript) {
        <av-tooltip message="Download">
          <button
            [attr.aria-label]="'Download' | translate"
            avButton
            size="xs"
            ofType="icon"
            color="link"
            (click)="download()"
            [disabled]="isLoadingContent()"
          >
            <av-icon size="sm" name="document-download"></av-icon>
          </button>
        </av-tooltip>
        } @if (!!transcriptUrl()) {
        <av-tooltip message="Download">
          <a
            [attr.aria-label]="'Download' | translate"
            avButton
            size="xs"
            ofType="icon"
            color="link"
            [href]="transcriptUrl()"
            download="{{ transcriptStatus().languageName }}"
            target="_blank"
          >
            <av-icon size="sm" name="document-download"></av-icon>
          </a>
        </av-tooltip>
        <av-copy-clipboard
          [url]="transcriptUrl()"
          size="xs"
        ></av-copy-clipboard>
        }
      </div>
    </ng-container>
  </av-card-row-responsive>
  @if (isContentExpanded()) {
  <av-card-body type="spotlight" class="content">
    <av-copy-clipboard
      size="xs"
      class="card-action"
      [tooltipLabel]="'Copy to clipboard' | translate"
      [url]="copyData()"
    ></av-copy-clipboard>
    <app-composition-transcript-content
      [data]="content().chatTranscriptList"
    ></app-composition-transcript-content>
  </av-card-body>
  }
</av-card-row>
} @if (isTranscriptCompleted() && !!conversationId()) { @if (!!transformSummary())
{
<av-card-row>
  <app-composition-transcript-transform
    [transform]="transformSummary()"
    [conversationId]="conversationId()"
    [transcriptId]="transcriptStatus().id"
    transformType="summary"
    (removed)="transformSummary.set(undefined)"
  ></app-composition-transcript-transform>
</av-card-row>
} @if (!!transformTranslation()) {
<av-card-row>
  <app-composition-transcript-transform
    [transform]="transformTranslation()"
    [conversationId]="conversationId()"
    [transcriptId]="transcriptStatus().id"
    transformType="translation"
    (removed)="transformTranslation.set(undefined)"
  ></app-composition-transcript-transform>
</av-card-row>
} @if (!!transformSentiment()) {
<av-card-row>
  <app-composition-transcript-transform
    [transform]="transformSentiment()"
    [conversationId]="conversationId()"
    [transcriptId]="transcriptStatus().id"
    transformType="sentiment"
    (removed)="transformSentiment.set(undefined)"
  ></app-composition-transcript-transform>
</av-card-row>
} @if (!!transformPrompt()) {
<av-card-row>
  <app-composition-transcript-transform
    [transform]="transformPrompt()"
    [conversationId]="conversationId()"
    [transcriptId]="transcriptStatus().id"
    transformType="prompt"
    (removed)="transformPrompt.set(undefined)"
  ></app-composition-transcript-transform>
</av-card-row>
} }
